import { useEffect, useState } from "react";
import { CalendarViewType } from "../components/calendar.ts";

/**
 * Picks the calendar view type based on viewport width:
 * a single day below the `md` breakpoint (768px), the full week above it.
 */
export const useResponsiveCalendar = () => {
  const [isSmallScreen, setIsSmallScreen] = useState(
    typeof window !== "undefined" && window.innerWidth < 768,
  );

  useEffect(() => {
    const checkScreenSize = () => setIsSmallScreen(window.innerWidth < 768);

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const calendarViewType = isSmallScreen
    ? CalendarViewType.DAY
    : CalendarViewType.WEEK;

  return { calendarViewType };
};
